// Vendors
import { FeatureFlagsLendingOnboardingEnumeration } from '@gruposantander/opbpay-ui-core-models';
// Contexts
import { useFeatureFlagsContextHook } from 'contexts/feature-flags.context';
// Types
import { FeatureFlagsHookType } from './types/feature-flags.hook.type';
// Utilities
import { isFeatureFlagLoadedAndIsNotVisible } from 'utils/feature-flag.utils';

const useFeatureFlagsHook = (): FeatureFlagsHookType => {
  const { featureFlags } = useFeatureFlagsContextHook();

  return {
    isUsableFeature: (id: FeatureFlagsLendingOnboardingEnumeration) =>
      !isFeatureFlagLoadedAndIsNotVisible({ featureFlags, id }),
  };
};

export { useFeatureFlagsHook };
